export const memoryFactsKeys = {
    all: () => ['memoryFacts'],
    clusters: () => [...memoryFactsKeys.all(), 'clusters'],
    facts: (clusterId) => [...memoryFactsKeys.all(), 'facts', clusterId ?? null]
};
//# sourceMappingURL=memoryFacts.keys.js.map